<template>
  <div class="home">

    <img alt="Vue logo" src="@/assets/IOIHANlogo300x502.png">
    <br>
    <small>App Version {{$root.version}}</small>

    <div v-if="quote" class="quote-card">
      <img class="quote-image" :src="quote.quotes[0].background">
      <div class="quote-text">{{quote.quotes[0].quote}}<span class="quote-author">{{quote.quotes[0].author}}</span></div>
      <div class="quote-credits"><a href="https://theysaidso.com/">Courtesy "They Said So"</a></div>
    </div>

    <b-card v-else class="card col-md-6 shadow mr-auto ml-auto mt-5" style="border-radius:1em;">
      <h4>Samples Listing</h4>
      <ul style="list-style:none;padding:0;">
        <li>Tickets</li>
        <li>Order Calendar</li>
        <li>FAQ Control</li>
        <li>Hourly Chart</li>
        <li>Survey Rating Control</li>
      </ul>
    </b-card>
  </div>
</template>

<script>
  // @ is an alias to /src

  import axios from 'axios';

  export default {
    name      : 'home',
    components: {},
    data() {
      return {

        quote: null

        // {
        //   "success" : {
        //     "total": 1
        //   },
        //   "contents": {
        //     "quotes": [
        //       {
        //         "quote"     : "Do not worry if you have built your castles in the air. They are where they should be. Now put the foundations under them.",
        //         "length"    : "122",
        //         "author"    : "Henry David Thoreau",
        //         "tags"      : [
        //           "dreams",
        //           "inspire",
        //           "worry"
        //         ],
        //         "category"  : "inspire",
        //         "date"      : "2016-11-21",
        //         "title"     : "Inspiring Quote of the day",
        //         "background": "https://theysaidso.com/img/bgs/man_on_the_mountain.jpg",
        //         "id"        : "mYpH8syTM8rf8KFORoAJmQeF"
        //       }
        //     ]
        //   }
        // }
      }
    }
    ,
    created() {
      this.getQuote();
    },
    methods   : {
      async getQuote() {

        try {
          let response = await axios({ method: 'get', url: 'https://quotes.rest/qod' });
          this.quote = response.data.contents;
          console.log( JSON.stringify(response.data,null,2));

        } catch( error ) {
          this.quote = null;              // just disable this on error -  it's not critical and this service has a rate limit...
          console.log( "oops" , error );
        }

      }

    }
  }


</script>

<style lang="scss" scoped>

  .quote-card {
    width: 60%;
    position: relative;
    text-align: center;

    margin:auto;
    margin-top:3em;
    padding:10px;
  }
   .quote-image {
      position:relative;
      width:100%;
      height: auto;
      border-radius: 2em;
      border: 5px black solid;
      -webkit-box-shadow: -12px 12px 15px 2px rgba(0, 0, 0, 0.72);
      box-shadow: -12px 12px 15px 2px rgba(0, 0, 0, 0.72);
    }

    .quote-text {
      position:absolute ;
      color: #111;
      top:120px;
      left:50%;
      font-family: Helvetica sans-serif;
      font-size:28px;
      line-height:1em;
      font-weight:800;
      //text-shadow: -4px 5px 5px #130228;
      // text-shadow: -4px 5px 19px rgba(19,2,40,0.98);
      text-shadow: -4px 5px 19px rgba(240,240,240,1);
      width: 80%;
      text-align:center;
      transform: translate(-50%, -50%);

      span:before {
        content: "-";
        font-size: 12px;
        color:black;
        padding-left: 2em;
      }

      span {
        content: "eee";
        font-style: italic;
        font-size: 12px;
        color:black;
        padding-left:1em;
        float:right;
      }
    }


  .quote-credits {
    position:absolute;
    font-size:18px;
    bottom:20px;
    left:10%;
    color: white;
    a {
      font-style:italic;
      color:white;
    }
  }

  @media screen and (max-width: 1024px) {

    .quote-text {
      top:90px;
      font-size:16px;
    }

    .quote-credits {
      font-size:12px;
    }
  }

  .cat-image {
    margin-top: 3em;
    border: 3px solid gray;
    -webkit-box-shadow: -12px 12px 15px 2px rgba(0, 0, 0, 0.72);
    box-shadow: -12px 12px 15px 2px rgba(0, 0, 0, 0.72);
    border-radius: 50%;
  }

</style>
